import { useEffect, useMemo, useState } from 'react'
import { useHistory } from 'react-router-dom'

import { goToUrl } from '../../utils'
import { Button, Table } from '..'

import { IconEditSvg, PlusSvg } from '../../assets/icons/svgComponents'

import * as S from './styles'
import { fetchAllconstructs } from '../../../main/usecases/admin-menu/construct'
import {
  allConstructsModel,
  constructContentModel
} from '../../../domain/models/admin-models'
import { useAlert } from 'react-alert'

const NewConstruct = () => {
  const [page, setPage] = useState(1)
  const alert = useAlert()
  const history = useHistory()
  const [constructs, setConstructs] = useState<allConstructsModel>()
  const columns = useMemo(
    () => [
      {
        Header: 'Código',
        accessor: 'nameToCodigo'
      },
      {
        Header: 'Construto',
        accessor: 'nameToConstruto'
      },
      {
        Header: '',
        accessor: 'actions'
      }
    ],
    []
  )
  useEffect(() => {
    ;(async () => {
      const allContructs = await fetchAllconstructs(page).load()
      setConstructs(allContructs)
    })()
  }, [page])
  const data = useMemo(() => {
    const handleRedirectToRegistrationData = async (
      construct: constructContentModel
    ) => {
      try {
        goToUrl(history, `/novo-construto`, {
          categoriaConstruto: construct.categoriaConstruto
            ? construct.categoriaConstruto
            : '',
          cdConstruto: construct.cdConstruto ? construct.cdConstruto : '',
          construto: construct.construto ? construct.construto : ''
        })
      } catch (error) {
        console.error(error)
        alert.show('Erro ao entrar em um teste', {
          type: 'error',
          timeout: 4000
        })
      }
    }

    return constructs?.content?.map((item) => {
      return {
        nameToCodigo: item?.cdConstruto,
        nameToConstruto: item?.construto,
        actions: (
          <div className="table-icons">
            <button
              onClick={() => handleRedirectToRegistrationData(item)}
              title="Editar"
            >
              <IconEditSvg />
            </button>
          </div>
        )
      }
    })
  }, [alert, constructs?.content, history])
  return (
    <S.Wrapper>
      <S.Title>Construtos</S.Title>
      <S.Body>
        <Button
          initialIcon={<PlusSvg />}
          onClick={() => goToUrl(history, '/novo-construto')}
        >
          Novo cadastro
        </Button>
        <S.TableContainer>
          <Table
            onClick={() => ({})}
            columns={columns}
            dataTable={data || []}
            handlePageClick={(currentPage: any) =>
              setPage(currentPage.selected + 1)
            }
            pageCount={constructs?.totalPages}
          />
        </S.TableContainer>
      </S.Body>
    </S.Wrapper>
  )
}
export default NewConstruct
